"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var RadioButton_1 = __importDefault(require("./RadioButton"));
/**
 * Design System: Radio Button Group Component. (Created only as a shortcut for creating a group of Radio Buttons
 * Can be used to render a group of Radio Buttons or as a part of bigger/more complex components (e.g. Radio Button Group).
 */
var RadioButtonsGroup = function (_a) {
    var radioButtons = _a.radioButtons, _b = _a.defaultValue, defaultValue = _b === void 0 ? '' : _b, onChange = _a.onChange;
    var _c = (0, react_1.useState)(defaultValue), selectedValue = _c[0], setSelectedValue = _c[1];
    var handleChange = (0, react_1.useCallback)(function (event) {
        setSelectedValue(event.target.value);
        if (onChange) {
            onChange(event);
        }
    }, [setSelectedValue, onChange]);
    var isSelectedButton = (0, react_1.useCallback)(function (value) { return value === selectedValue; }, [selectedValue]);
    return (react_1.default.createElement(react_1.default.Fragment, null, radioButtons.map(function (radioButtonProps) { return (react_1.default.createElement(RadioButton_1.default, __assign({ key: radioButtonProps.value }, radioButtonProps, { onChange: handleChange, checked: isSelectedButton(radioButtonProps.value) }))); })));
};
exports.default = RadioButtonsGroup;
